export default __webpack_public_path__ + "i18n/translations/translation-ko.e9486075.json";